export default "__VITE_ASSET__BEHNVnC6__"